export default "__VITE_ASSET__F06Fa9b8__"